import * as React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, TextField, InputAdornment, CircularProgress } from '@mui/material';
import { H3, Body2, Body3 } from '../../../themes/typography';
import useAuthNavigation from '../useAuthNavigation';
import useHandleGuestLogin from './hooks/useHandleGuestLogin';
import '../../../styles/components/LoginForm.css';

export default function GuestLogin() {
    const { showLoginForm } = useAuthNavigation();
    const { loading } = useSelector((state) => state.auth);
    const { formik } = useHandleGuestLogin();

    return (
        <React.Fragment>
            <div className="main-login-email-collect-container">
                <div className="login-welcome-greetings">
                    <H3 color="var(--secondary-color)" fontWeight={700}>
                        Guest Login
                    </H3>
                    <Body2 color="var(--tertiary-color)">Enter your details for guest access</Body2>
                </div>

                <form className="main-login-form" onSubmit={formik.handleSubmit} autoComplete="off">
                    <div className="different-login-forms">
                        <div className="main-switchable-login-form">
                            <div className="guest-login-input-container">
                                <TextField
                                    fullWidth
                                    id="guestEmail"
                                    name="guestEmail"
                                    label="Email"
                                    value={formik.values.guestEmail}
                                    disabled={loading}
                                    onChange={(e) =>
                                        formik.setFieldValue('guestEmail', e.target.value)
                                    }
                                    error={
                                        formik.touched.guestEmail &&
                                        Boolean(formik.errors.guestEmail)
                                    }
                                    helperText={
                                        formik.touched.guestEmail && formik.errors.guestEmail
                                    }
                                />
                                <TextField
                                    fullWidth
                                    id="guestPhone"
                                    name="guestPhone"
                                    label="Phone Number"
                                    value={formik.values.guestPhone}
                                    disabled={loading}
                                    onChange={(e) =>
                                        formik.setFieldValue('guestPhone', e.target.value)
                                    }
                                    error={
                                        formik.touched.guestPhone &&
                                        Boolean(formik.errors.guestPhone)
                                    }
                                    helperText={
                                        formik.touched.guestPhone && formik.errors.guestPhone
                                    }
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    +91
                                                </InputAdornment>
                                            ),
                                            inputMode: 'numeric',
                                            pattern: '[0-9]*',
                                            onInput: (e) => {
                                                e.target.value = e.target.value.replace(/\D/g, '');
                                                if (e.target.value.length > 10) {
                                                    e.target.value = e.target.value.slice(0, 10);
                                                }
                                            }
                                        }
                                    }}
                                />
                            </div>

                            <div className="login-methods-container">
                                <div className="login-methods-action-buttons">
                                    <Button
                                        variant="main"
                                        fullWidth
                                        type="submit"
                                        disabled={loading}
                                    >
                                        Guest Login{' '}
                                        {loading && (
                                            <CircularProgress
                                                size={20}
                                                sx={{
                                                    marginLeft: '0.75rem',
                                                    color: 'var(--primary-color)'
                                                }}
                                            />
                                        )}
                                    </Button>
                                    <Button disableRipple sx={backToOption} onClick={showLoginForm}>
                                        Back to options
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

                <div className="login-terms-agree-container">
                    <Body3>
                        By signing in you accept Shmooz {''}
                        <span className="terms">
                            <Link>Terms of Service</Link>
                        </span>{' '}
                        and
                        <span className="terms">
                            {' '}
                            {''}
                            <Link>Privacy Policy</Link>
                        </span>
                    </Body3>
                </div>
            </div>
        </React.Fragment>
    );
}

const backToOption = {
    padding: '0',
    fontSize: '0.875rem',
    color: '#ccc',
    '&:hover': {
        textDecoration: 'underline'
    }
};
